import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, Progress} from "reactstrap";
import {Objects} from "components";
import PropTypes from "prop-types";
import UserRoles from "../../constants/UserRoles";
import APPCONFIG from "../../constants/Config";
import API from "@beardeddevops/react.api";
import Types from "../../constants/Types";
import Select from "react-select";
import moment from 'moment-timezone';
import GradeComponent from "../Objects/GradeComponent";
import Assessment from "@material-ui/icons/Assessment";
import {Tooltip} from "@material-ui/core";
import Collections from "../Collections";
import {Link} from "react-router-dom";

class NavLeftList extends Framework.Components.View {
	static propTypes = {
		roles: PropTypes.array
	};

	constructor(props) {
		super(props);
		this.state.phoneLogs = false;
		this.state.helpDesks = false;
		this.state.dispatchTracker = false;     // AFK modal
		this.state.idleModal = false;          // Idle modal
		this.state.modal_daily = false;
		this.state.timeTrackingTriggered = false;
		this.state.idleTrackingTriggered = false;
		this.state.active = this.props.active ?? true;
		this.state.isIdle = this.props.isIdle ?? false;
		this.state.selectedStatus = {value: 2, label: 'Start Break'};
		this.state.activity_types = [];
		this.state.activitystatus = false;
		this.state.current_activity = null;
		this.state.totalTime = '';
		this.state.modalFilterDate = moment().format();
	}

	handleClose = () => {
		this.setState({
			anchorEl: null,
			anchorE2: null
		});
	};

	handleToggleModal = async (modal) => {
		this.setState({[modal]: !this.state[modal], modalFilterDate: moment().format(), week_view: null});
		if (modal === 'phoneLogs') {
			let modelPhoneLogClicked = new API.BuildClass(Types.Dispatch._name, API.RequestType.CREATE);
			await modelPhoneLogClicked.submit(null, 'PUT_PHONE_LOG_MODAL', true);
		}
		if ((modal === 'phoneLogs' || modal === 'activitystatus') && this.props.rootState.roles.includes(UserRoles.Dispatch)) {
			let modelCurrentTime = new API.BuildClass(Types.Dispatch._name, API.RequestType.READ);
			let totalTime = await modelCurrentTime.submit(null, 'GET_CURRENT_TIME');
			totalTime = typeof (totalTime) === 'string'
				? totalTime
				: (Math.floor(moment.duration(totalTime, 'seconds').asHours()) + 'h ' +
					moment.duration(totalTime, 'seconds').minutes() + 'm' + ' worked today.');
			this.setState({totalTime});
		}
	};

	redirectTo = (objectType) => {
		this.props.history.push('/' + objectType);
	};

	componentDidMount() {
		this.getActivityTypes();

		// Only drive AFK/Idle logic outside dev
		if (!APPCONFIG.settings.isDev()) {
			window.addEventListener("storage", this.onStorageUpdate);
			this.modalDriver = setInterval(this.driveModalSystem, 1500);
			this.driveModalSystem();
		}
	}

	componentWillUnmount() {
		//if (!APPCONFIG.settings.isDev()) {
			window.removeEventListener("storage", this.onStorageUpdate);
			if (this.modalDriver) {
				clearInterval(this.modalDriver);
			}
		//}
	}

	driveModalSystem = () => {
		//if (APPCONFIG.settings.isDev()) return;

		const lsAFK = localStorage.getItem("timeTrackingModal") === "true";
		const lsIdle = localStorage.getItem("idleModal") === "true";
		const hasCompetingModal = !!(this.state.phoneLogs || this.state.helpDesks || this.state.activitystatus);

		// localStorage is the authority: AFK > Idle
		// Close competing user modals so reactstrap never stacks AFK/Idle under phone log etc.
		if (lsAFK) {
			if (!this.state.dispatchTracker || this.state.idleModal || hasCompetingModal) {
				this.setState({
					dispatchTracker: true,
					idleModal: false,
					phoneLogs: false,
					helpDesks: false,
					activitystatus: false
				});
			}
			return;
		}

		if (lsIdle) {
			if (!this.state.idleModal || this.state.dispatchTracker || hasCompetingModal) {
				this.setState({
					idleModal: true,
					dispatchTracker: false,
					phoneLogs: false,
					helpDesks: false,
					activitystatus: false
				});
			}
			return;
		}

		// Neither LS flag: close both if they're open
		if (this.state.dispatchTracker || this.state.idleModal) {
			this.setState({
				dispatchTracker: false,
				idleModal: false
			});
		}
	};

	onStorageUpdate = (e) => {
		if (APPCONFIG.settings.isDev()) return;
		if (e && e.key && e.key !== "timeTrackingModal" && e.key !== "idleModal") return;
		this.driveModalSystem();
	};

	getActivityTypes = async () => {
		let modelActivityTypes = new API.BuildClass(Types.Activity_Types._name, API.RequestType.GET_ALL);
		const activityTypes = await modelActivityTypes.submit(null, 'GET_ALL', true);
		this.setState({
			activity_types: activityTypes.items.filter((item) => [2, 4].includes(item.pkey))
		}); // only clock out and start break
	};

	handleTimeTrackingClose = async () => {
		this.props.rootState.set({active: true, isIdle: false});
		this.props.rootState.active = true;
		this.props.rootState.isIdle = false;

		this.setState({
			dispatchTracker: false,
			idleModal: false,
			timeTrackingTriggered: false,
			idleTrackingTriggered: false
		});

		localStorage.setItem("timeTrackingModal", "false");
		localStorage.setItem("idleModal", "false");
	};

	handleIdleModalClose = async () => {
		this.props.rootState.set({active: true, isIdle: false});
		this.props.rootState.active = true;
		this.props.rootState.isIdle = false;

		this.setState({
			idleModal: false,
			dispatchTracker: false,
			idleTrackingTriggered: false,
			timeTrackingTriggered: false
		});

		localStorage.setItem("timeTrackingModal", "false");
		localStorage.setItem("idleModal", "false");
	};

	handleActivityChange = async (key) => {
		this.state.selectedStatus = null;
		let modelActivityLog = new API.BuildClass(Types.Activity_Logs._name, API.RequestType.CREATE);
		modelActivityLog.object.activity_type = key;
		await modelActivityLog.submit(null, 'PUT', true);
		const data = await this.props.rootState.triggerAction('getUserInformation', {fromRouteChange: false, forceTrigger: true});
		this.setState({activitystatus: false, current_activity: data.current_activity});
	};

	copyLink = async () => {
		//places that use localstorage directly instead of the filters: calendar

		//get whatever page they are on and copy the table-filters unless one of the above places then specifically grab things for the link
		const params = new URLSearchParams();
		let stored_object = {};
		let stored;
		//change to switch if we need more than calendar
		if(window.location.pathname === '/dispatch/calendar'){
			stored = '/dispatch/calendar';
			const store_users = localStorage.getItem('users');
			const store_regions = localStorage.getItem('regions');
			const store_date = localStorage.getItem('date');
			if(store_users) {
				stored_object['users'] = store_users;
			}
			if(store_regions) {
				stored_object['regions'] = store_regions;
			}
			if(store_date) {
				stored_object['date'] = store_date;
			}
			// params.set(stored, encodeURIComponent(btoa(JSON.stringify(stored_object))));
		} else {
			stored = localStorage.getItem('current_preset');
			if (stored) {
				const preset = localStorage.getItem(stored);
				if (preset) {
					stored_object = {[stored]: preset};
					// params.set(stored, encodeURIComponent(btoa(JSON.stringify(stored_object))));
				}
			}
		}
		params.set(stored, encodeURIComponent(btoa(JSON.stringify(stored_object))));


		let modelLink = new API.BuildClass(Types.Links._name, API.RequestType.CREATE);
		modelLink.object.pathname = window.location.pathname;
		modelLink.object.preference = stored;
		modelLink.object.data_to_be_set = btoa(JSON.stringify(stored_object));
		let resultData = await modelLink.submit(null, 'PUT');
		navigator.clipboard.writeText(`${window.location.origin}/links/${resultData.uuid}`).then();

		//put toast that the link was copied here
	}

	render() {
		const {roles, history} = this.props;

		let activityRender = null;

		const main_role = this.props.rootState.main_role ?? 10;

		if (roles.some(role => [UserRoles.Dispatch, UserRoles.Manager].includes(role))) {

			const current_activity = this.state.current_activity
				? this.state.current_activity.activity_type
				: this.props.rootState.current_activity
					? this.props.rootState.current_activity.activity_type
					: null;

			const timestamp = this.state.current_activity
				? moment(this.state.current_activity.created).format('h:mm:ss A')
				: this.props.rootState.current_activity
					? moment(this.props.rootState.current_activity.created).format('h:mm:ss A')
					: null;

			switch (current_activity) {
				case null:
					activityRender = <>
						<Button color={'none'} id="phoneLog" onClick={() => {
							this.handleActivityChange(1);
						}} className="md-button header-btn">
							Clock In
						</Button>
					</>;
					break;
				case 4:
					activityRender = <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
						<Button color={'none'} id="phoneLog" onClick={() => {
							this.handleActivityChange(1);
						}} className="md-button header-btn">
							Clock In
						</Button>
						<b>
							Clocked out at: {timestamp}
						</b>
					</div>;
					break;
				case 2:
					activityRender = <>
						<Button color={'none'} id="phoneLog" onClick={() => {
							this.handleActivityChange(3);
						}} className="md-button header-btn">
							End Break
						</Button>
						<b>
							On break {timestamp}
						</b>
					</>;
					break;
				case 3:
				case 1:
					activityRender = <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
						<Button color={'none'} id="phoneLog" onClick={() => {
							this.setState({activitystatus: true});
						}} className="md-button header-btn">
							Break or Clock Out
						</Button>
						<b>
							Clocked in {timestamp}
						</b>
					</div>;
					break;
			}

		}
		return (
			<div>

				<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>

					{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) &&
						<div style={{display: 'flex', flexDirection: "row", alignItems: 'flex-end'}}>
							<div>
								<Button color={'none'} id="phoneLog" onClick={() => {
									this.handleToggleModal('phoneLogs');
								}} className="md-button header-btn">
									Add Phone Log
								</Button>
							</div>
							<div>
								<Link to={`/dispatch/calendar`} variant={'text'}>
									<Button color={'none'} id="calendar" className="md-button header-btn">
										Calendar
									</Button>
								</Link>
							</div>
							<div>
								<Link to={`/copyables`} variant={'text'}>
									<Button color={'none'} id="copyables" className="md-button header-btn">
										Copyables
									</Button>
								</Link>
							</div>
							<div>
								<Button color={'none'} id="phoneLog" onClick={this.copyLink} className="md-button header-btn">
									Copy Link
								</Button>
							</div>
						</div>
					}
					{roles.some(role => [UserRoles.Dispatch].includes(role)) &&
						<div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
							{activityRender}
						</div>
					}
					{roles.some(role => [UserRoles.FieldEngineer].includes(role)) &&
						<div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
							<Button color={'none'} id="helpDesk" onClick={() => {
								this.handleToggleModal('helpDesks');
							}} className="md-button header-btn">
								Create Helpdesk
							</Button>
						</div>
					}
					{this.props.thermometer_data !== null && <>
						{this.props.thermometer_data.score_day != 0 &&
							<Tooltip title={'Show Hourly Breakdown'}>
								<Button color="info" size={"sm"} block={false}
								        style={{height: '2rem', alignSelf: 'end', marginRight: 5}} onClick={() => {
									let score = Math.round(this.props.thermometer_data.letter_score_day * 10) / 10;
									if (score.toString().includes('.0')) {
										score = score.toString().split('.')[0];
									}
									this.setState({
										user: this.props.account, modal_daily: true,
										name: this.props.name, day_score_display: score,
										day_score: this.props.thermometer_data.letter_score_day
									});
								}}>
									<Assessment fontSize={'small'}/>
								</Button>
							</Tooltip>}
						<div style={{display: 'flex', flexDirection: 'column', width: '150px'}}>
							<div className={'text-center'}
							     style={{
								     fontSize: '15px',
								     display: 'flex',
								     flexDirection: 'column',
								     justifyContent: 'space-between'
							     }}>
								{this.props.thermometer_data.score_hour > this.props.thermometer_data.hourly_limit ?
									`Goal Hit! Bonus: ${this.props.thermometer_data.score_hour - this.props.thermometer_data.hourly_limit}`
									: `Hourly - ${this.props.thermometer_data.score_hour} of ${this.props.thermometer_data.hourly_limit}`}
								{this.props.thermometer_data.letter_score_hour !== 0 &&
									<GradeComponent score={this.props.thermometer_data.letter_score_hour}
									                type={main_role === 25 ? 'helpdesk' : main_role === 26 ? 'hiring' : null}/>}
							</div>
							<Progress multi style={{width: '250px'}}>
								{this.props.thermometer_data.score_hour > this.props.thermometer_data.hourly_limit ? <>
										<Progress bar
										          value={this.props.thermometer_data.hourly_limit}
										          max={this.props.thermometer_data.hourly_limit * 2}
										          color={'success'}
										          style={{width: '250px'}}>
											{this.props.thermometer_data.hourly_limit}
										</Progress>
										<Progress
											bar value={this.props.thermometer_data.score_hour - this.props.thermometer_data.hourly_limit}
											max={this.props.thermometer_data.hourly_limit * 2}/>
									</>
									: <Progress bar value={this.props.thermometer_data.score_hour}
									            max={this.props.thermometer_data.hourly_limit}
									            color={'success'} style={{width: '250px'}}/>}
							</Progress>
						</div>
						{this.props.thermometer_data.additional_data ?
							<div style={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'flex-end',
								fontSize: '16px',
								marginLeft: 15,
								marginRight: 15
							}}>
								{this.props.thermometer_data.additional_text}{this.props.thermometer_data.additional_data}
							</div> :
							<span style={{marginLeft: '5px', marginRight: '5px'}}></span>}
						<div style={{display: 'flex', flexDirection: 'column', width: '150px', paddingRight: 5}}>
							<div className={'text-center'}
							     style={{
								     fontSize: '15px',
								     display: 'flex',
								     flexDirection: 'column',
								     justifyContent: 'space-between'
							     }}>
								{this.props.thermometer_data.score_day > this.props.thermometer_data.daily_limit ?
									`Goal Hit! Bonus: ${this.props.thermometer_data.score_day - this.props.thermometer_data.daily_limit}` :
									`Daily - ${this.props.thermometer_data.score_day} of ${this.props.thermometer_data.daily_limit}`}
								{this.props.thermometer_data.letter_score_day !== 0 && this.props.thermometer_data.letter_score_day_offset &&
									<GradeComponent
										score={(Math.round(this.props.thermometer_data.letter_score_day_offset * 10) / 10) ===
										(Math.round(this.props.thermometer_data.letter_score_hour * 10) / 10)
											? this.props.thermometer_data.letter_score_day
											: this.props.thermometer_data.letter_score_day_offset}
										type={main_role === 25 ? 'helpdesk' : null}/>}
								{this.props.thermometer_data.letter_score_day !== 0 &&
									<GradeComponent score={this.props.thermometer_data.letter_score_day}
									                type={main_role === 25 ? 'helpdesk' : main_role === 26 ? 'hiring' : null}/>}
							</div>
							<Progress multi style={{width: '250px'}}>
								{this.props.thermometer_data.score_hour > this.props.thermometer_data.daily_limit ? <>
										<Progress bar
										          style={{width: '250px'}}
										          value={this.props.thermometer_data.daily_limit}
										          max={this.props.thermometer_data.daily_limit * 2}
										          color={'success'}>
											{this.props.thermometer_data.daily_limit}
										</Progress>
										<Progress
											bar style={{width: '250px'}}
											value={this.props.thermometer_data.score_day - this.props.thermometer_data.daily_limit}
											max={this.props.thermometer_data.daily_limit * 2}/>
									</>
									: <Progress bar style={{width: '250px'}}
									            value={this.props.thermometer_data.score_day}
									            max={this.props.thermometer_data.daily_limit}
									            color={'success'}/>}
							</Progress>
						</div>
						{this.props.thermometer_data.score_day != 0 &&
							<Tooltip title={'Show Daily Breakdown'}>
								<Button color="info" size={"sm"} block={false}
								        style={{height: '2rem', alignSelf: 'end'}} onClick={() => {
									let score = Math.round(this.props.thermometer_data.letter_score_day * 10) / 10;
									if (score.toString().includes('.0')) {
										score = score.toString().split('.')[0];
									}
									this.setState({
										user: this.props.account,
										modal_daily: true,
										name: this.props.name,
										day_score_display: score,
										day_score: this.props.thermometer_data.letter_score_day,
										week_view: true
									});
								}}>
									<Assessment fontSize={'small'}/>
								</Button>
							</Tooltip>}
					</>}
				</div>

				<Framework.Elements.UniversalModal
					size={"xl"}
					name={`${this.state.week_view ? "Daily" : "Hourly"} Breakdown for ${this.props.name}`}
					object={main_role === 25 ? Collections.HelpdeskScores : main_role === 26 ? Collections.HiringScores : Collections.DispatcherScores}
					history={this.props.history}
					showModal={!!this.state.modal_daily}
					handleToggle={() => this.handleToggleModal('modal_daily')}
					objectProps={{
						user: this.state.user,
						filterDate: this.state.modalFilterDate,
						name: this.props.name,
						day_score_display: this.state.day_score_display,
						day_score: this.state.day_score,
						week_score_display: this.state.week_score_dislay,
						week_score: this.state.week_score,
						week_view: this.state.week_view,
						changeFilterDate: (date) => this.setState({modalFilterDate: date})
					}}
					hideGoTo={true}
					hasSubmit={false}
				/>

				<Modal
					isOpen={this.state.activitystatus}
					toggle={() => {
						this.setState({activitystatus: false});
					}}
					size={"md"}
					backdrop={true}
				>
					<ModalHeader>
						Select a Status | {this.state.totalTime}
					</ModalHeader>
					<ModalBody>
						<Select
							key={this.state.activity_types.length}
							placeholder={"Activity Status"}
							value={this.state.selectedStatus}
							onChange={(value) => {
								this.setState({selectedStatus: value});
							}}
							options={this.state.activity_types.map(item => {
								return ({value: item.pkey, label: item.activity_name});
							})}
							fullWidth={true}
						/>
					</ModalBody>
					<ModalFooter>
						<Button color="secondary" onClick={() => {
							this.setState({activitystatus: false});
						}}>Close</Button>
						{this.state.selectedStatus &&
							<Button color="primary" onClick={async () => {
								await this.handleActivityChange(this.state.selectedStatus.value);
							}}>Confirm</Button>}
					</ModalFooter>
				</Modal>

				<Framework.Elements.UniversalModal
					locations={this.props.regions}
					title={this.props.rootState.roles.includes(UserRoles.Dispatch) ? "Phone Log | " + this.state.totalTime : null}
					name={"Phone Log"}
					object={Objects.PhoneLog}
					history={history}
					showModal={!!this.state.phoneLogs}
					reportClose={() => {
						this.handleToggleModal('phoneLogs');
					}}
					afterSave={() => {
						localStorage.setItem('phoneLogData', 'submitted');
					}}
					additionalButtons={
						<>
							<Button
								data-id={'clear-phoneLog'}
								color="danger"
								onClick={() => {
									localStorage.setItem('phoneLogData', 'cleared');
								}}>
								Clear
							</Button>
						</>
					}
					size={"xl"}
					objectProps={{isNew: true}}
				/>

				<Framework.Elements.UniversalModal
					locations={this.props.regions}
					title={"Help Desk"}
					object={Objects.HelpDeskAdd}
					history={history}
					showModal={!!this.state.helpDesks}
					reportClose={() => {
						this.handleToggleModal('helpDesks');
					}}
				/>

				<Framework.Elements.UniversalModal
					showModal={!!this.state.dispatchTracker}
					title={"Time Tracking"}
					object={Objects.DispatcherTracker}
					history={history}
					submitLabel={"Record Answer"}
					hasCancel={false}
					backdrop={"static"}
					reportClose={this.handleTimeTrackingClose}
					afterSave={this.handleTimeTrackingClose}
				/>

				<Framework.Elements.UniversalModal
					showModal={!!this.state.idleModal}
					title={"Idle Tasks"}
					object={Collections.IdleTasks}
					history={history}
					hasSubmit={false}
					hasCancel={false}
					backdrop={"static"}
					reportClose={this.handleIdleModalClose}
					additionalButtons={
						<>
							<Button
								data-id={'clear-phoneLog'}
								color="primary"
								onClick={async () => {
									let model = API.BuildClass(Types.Recurring_Tasks_Clicked._name, API.RequestType.CREATE);
									model.object.task = null;
									model.object.user = this.props.account;
									await model.submit(null, "PUT", true);
									await this.handleIdleModalClose();
								}}>
								I'm on a Phone Call
							</Button>
						</>
					}
					objectProps={{isAtLeastManager: false, all_roles: [30], filter: "Dispatch", user: this.props.account}}
				/>
			</div>
		);
	}
}

export default Framework.Components.withRootState(NavLeftList);
